import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { F3LoadingService } from '@f3/services/loading/loading.service';

@Injectable()
export class F3LoadingInterceptor implements HttpInterceptor
{
    handleRequestsAutomatically: boolean = true;

    /**
     * Constructor
     */
    constructor(
        private _f3LoadingService: F3LoadingService
    )
    {
        // Subscribe to the auto
        this._f3LoadingService.auto$
            .subscribe((value) => {
                this.handleRequestsAutomatically = value;
            });
    }

    /**
     * Intercept
     *
     * @param req
     * @param next
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
    {
        // return next.handle(req)

        // If the Auto mode is turned off, do nothing
        if ( !this.handleRequestsAutomatically )
        {
            return next.handle(req);
        }

        // Set the loading status to true
        this._f3LoadingService._setLoadingStatus(true, req.url);

        return next.handle(req).pipe(
            finalize(() => {
                // Set the status to false if there are any errors or the request is completed
                this._f3LoadingService._setLoadingStatus(false, req.url);
            }));
    }
}
